<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="用户姓名" prop="name">
                <Input type="text" v-model="searchForm.name" placeholder="请输入用户姓名" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="个人：笔名，企业：简称" prop="nickName">
                <Input type="text" v-model="searchForm.nickName" placeholder="请输入个人：笔名，企业：简称" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="认证方式  idcard：“身份证”  mainland_passport：“大陆护照”  mainland_officer  ：“大陆军官证” mainland_police ：大陆警官证 hongkong：“香港”   macao:澳门  taiwan：“台湾”  foreign ：“外籍” enterprise ：“企业”  ，这个字段主要用于组装天威诚信CA请求参数，不同的证件照采取不同的证件照" prop="authMethod">
                  <Input type="text" v-model="searchForm.authMethod" placeholder="请输入认证方式  idcard：“身份证”  mainland_passport：“大陆护照”  mainland_officer  ：“大陆军官证” mainland_police ：大陆警官证 hongkong：“香港”   macao:澳门  taiwan：“台湾”  foreign ：“外籍” enterprise ：“企业”  ，这个字段主要用于组装天威诚信CA请求参数，不同的证件照采取不同的证件照" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="权利人类型：person：“个人”  enterprise “企业”   和旧版权家的type字段相对应" prop="obligeeType">
                  <Input type="text" v-model="searchForm.obligeeType" placeholder="请输入权利人类型：person：“个人”  enterprise “企业”   和旧版权家的type字段相对应" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件类型：1：身份证，2：护照，3：军官证  4：企业法人营业执照    5 组织机构代码证书   6 事业单位法人证书  7社团法人证书  8 警官证  9 其他类型" prop="identityType">
                  <Input type="text" v-model="searchForm.identityType" placeholder="请输入证件类型：1：身份证，2：护照，3：军官证  4：企业法人营业执照    5 组织机构代码证书   6 事业单位法人证书  7社团法人证书  8 警官证  9 其他类型" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件号码" prop="identityNo">
                  <Input type="text" v-model="searchForm.identityNo" placeholder="请输入证件号码" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件号加密" prop="identityNoEncrypt">
                  <Input type="text" v-model="searchForm.identityNoEncrypt" placeholder="请输入证件号加密" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="国家" prop="country">
                  <Input type="text" v-model="searchForm.country" placeholder="请输入国家" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="省份" prop="province">
                  <Input type="text" v-model="searchForm.province" placeholder="请输入省份" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="城市" prop="city">
                  <Input type="text" v-model="searchForm.city" placeholder="请输入城市" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="联系人" prop="signature">
                  <Input type="text" v-model="searchForm.signature" placeholder="请输入联系人" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="登记人ID" prop="registerId">
                  <Input type="text" v-model="searchForm.registerId" placeholder="请输入登记人ID" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件扫描件2" prop="attachment2">
                  <Input type="text" v-model="searchForm.attachment2" placeholder="请输入证件扫描件2" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="" prop="attachment2Uuid">
                  <Input type="text" v-model="searchForm.attachment2Uuid" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件扫描件1" prop="attachment1">
                  <Input type="text" v-model="searchForm.attachment1" placeholder="请输入证件扫描件1" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="" prop="attachment1Uuid">
                  <Input type="text" v-model="searchForm.attachment1Uuid" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件扫描件3" prop="attachment3">
                  <Input type="text" v-model="searchForm.attachment3" placeholder="请输入证件扫描件3" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="" prop="attachment3Uuid">
                  <Input type="text" v-model="searchForm.attachment3Uuid" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件扫描件4" prop="attachment4">
                  <Input type="text" v-model="searchForm.attachment4" placeholder="请输入证件扫描件4" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件扫描件5" prop="attachment5">
                  <Input type="text" v-model="searchForm.attachment5" placeholder="请输入证件扫描件5" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件有效期开始时间" prop="attachStartTime">
                  <Input type="text" v-model="searchForm.attachStartTime" placeholder="请输入证件有效期开始时间" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证件有效期结束时间" prop="attachEndTime">
                  <Input type="text" v-model="searchForm.attachEndTime" placeholder="请输入证件有效期结束时间" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创建时间" prop="createdAt">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="是否是主要权利人0 不是  1是" prop="isRegister">
                  <Input type="text" v-model="searchForm.isRegister" placeholder="请输入是否是主要权利人0 不是  1是" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="地址" prop="address">
                  <Input type="text" v-model="searchForm.address" placeholder="请输入地址" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="0代表等待实名  1代表待提交证件，2代表已完成实名，,3代表实名驳回" prop="obligeeRealNameStatus">
                  <Input type="text" v-model="searchForm.obligeeRealNameStatus" placeholder="请输入0代表等待实名  1代表待提交证件，2代表已完成实名，,3代表实名驳回" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="" prop="mobilePhone">
                  <Input type="text" v-model="searchForm.mobilePhone" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="" prop="email">
                  <Input type="text" v-model="searchForm.email" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="如果法人为企业,这有‘企业法人姓名’" prop="legalName">
                  <Input type="text" v-model="searchForm.legalName" placeholder="请输入如果法人为企业,这有‘企业法人姓名’" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="如果法人为企业,这有‘企业法人身份证号’" prop="legalIdentityNo">
                  <Input type="text" v-model="searchForm.legalIdentityNo" placeholder="请输入如果法人为企业,这有‘企业法人身份证号’" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人证件图片正面" prop="legalPicCardOn">
                  <Input type="text" v-model="searchForm.legalPicCardOn" placeholder="请输入法人证件图片正面" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人证件图片反面" prop="legalPicCardBack">
                  <Input type="text" v-model="searchForm.legalPicCardBack" placeholder="请输入法人证件图片反面" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人证件有效期开始时间" prop="legalStartTime">
                  <Input type="text" v-model="searchForm.legalStartTime" placeholder="请输入法人证件有效期开始时间" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人证件有效期结束时间" prop="legalEndTime">
                  <Input type="text" v-model="searchForm.legalEndTime" placeholder="请输入法人证件有效期结束时间" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人实名认证状态" prop="legalStatus">
                  <Input type="text" v-model="searchForm.legalStatus" placeholder="请输入法人实名认证状态" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人实名认证原因" prop="legalVerifyReason">
                  <Input type="text" v-model="searchForm.legalVerifyReason" placeholder="请输入法人实名认证原因" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="是否修改过(0:未修改，1：修改)" prop="legalModifyFlag">
                  <Input type="text" v-model="searchForm.legalModifyFlag" placeholder="请输入是否修改过(0:未修改，1：修改)" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="权利人是否修改过(0:未修改，1：修改)" prop="modifyFlag">
                  <Input type="text" v-model="searchForm.modifyFlag" placeholder="请输入权利人是否修改过(0:未修改，1：修改)" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="入境证明URL" prop="enterCertify">
                  <Input type="text" v-model="searchForm.enterCertify" placeholder="请输入入境证明URL" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="人工审核状态（待审核，审核通过，审核驳回）wait_real_name_audit：待审核 complete_real_name_audit：审核通过 reject_real_name：审核驳回" prop="artificialAuditStatus">
                  <Input type="text" v-model="searchForm.artificialAuditStatus" placeholder="请输入人工审核状态（待审核，审核通过，审核驳回）wait_real_name_audit：待审核 complete_real_name_audit：审核通过 reject_real_name：审核驳回" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="人工审核状态变化时间" prop="auditStatusTime">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="银行预留手机号" prop="cardPhone">
                  <Input type="text" v-model="searchForm.cardPhone" placeholder="请输入银行预留手机号" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="银行卡号" prop="cardNo">
                  <Input type="text" v-model="searchForm.cardNo" placeholder="请输入银行卡号" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="备注信息" prop="remarks">
                  <Input type="text" v-model="searchForm.remarks" placeholder="请输入备注信息" clearable style="width: 200px"/>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        <FormItem label="用户姓名" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="个人：笔名，企业：简称" prop="nickName" >
          <Input v-model="form.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="认证方式  idcard：“身份证”  mainland_passport：“大陆护照”  mainland_officer  ：“大陆军官证” mainland_police ：大陆警官证 hongkong：“香港”   macao:澳门  taiwan：“台湾”  foreign ：“外籍” enterprise ：“企业”  ，这个字段主要用于组装天威诚信CA请求参数，不同的证件照采取不同的证件照" prop="authMethod" >
          <Input v-model="form.authMethod" style="width:100%"/>
        </FormItem>
        <FormItem label="权利人类型：person：“个人”  enterprise “企业”   和旧版权家的type字段相对应" prop="obligeeType" >
          <Input v-model="form.obligeeType" style="width:100%"/>
        </FormItem>
        <FormItem label="证件类型：1：身份证，2：护照，3：军官证  4：企业法人营业执照    5 组织机构代码证书   6 事业单位法人证书  7社团法人证书  8 警官证  9 其他类型" prop="identityType" >
          <Input v-model="form.identityType" style="width:100%"/>
        </FormItem>
        <FormItem label="证件号码" prop="identityNo" >
          <Input v-model="form.identityNo" style="width:100%"/>
        </FormItem>
        <FormItem label="证件号加密" prop="identityNoEncrypt" >
          <Input v-model="form.identityNoEncrypt" style="width:100%"/>
        </FormItem>
        <FormItem label="国家" prop="country" >
          <Input v-model="form.country" style="width:100%"/>
        </FormItem>
        <FormItem label="省份" prop="province" >
          <Input v-model="form.province" style="width:100%"/>
        </FormItem>
        <FormItem label="城市" prop="city" >
          <Input v-model="form.city" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人" prop="signature" >
          <Input v-model="form.signature" style="width:100%"/>
        </FormItem>
        <FormItem label="登记人ID" prop="registerId" >
          <Input v-model="form.registerId" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件2" prop="attachment2" >
          <Input v-model="form.attachment2" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="attachment2Uuid" >
          <Input v-model="form.attachment2Uuid" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件1" prop="attachment1" >
          <Input v-model="form.attachment1" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="attachment1Uuid" >
          <Input v-model="form.attachment1Uuid" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件3" prop="attachment3" >
          <Input v-model="form.attachment3" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="attachment3Uuid" >
          <Input v-model="form.attachment3Uuid" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件4" prop="attachment4" >
          <Input v-model="form.attachment4" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件5" prop="attachment5" >
          <Input v-model="form.attachment5" style="width:100%"/>
        </FormItem>
        <FormItem label="证件有效期开始时间" prop="attachStartTime" >
          <Input v-model="form.attachStartTime" style="width:100%"/>
        </FormItem>
        <FormItem label="证件有效期结束时间" prop="attachEndTime" >
          <Input v-model="form.attachEndTime" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createdAt" >
            <DatePicker type="date" v-model="form.createdAt" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="是否是主要权利人0 不是  1是" prop="isRegister" >
          <Input v-model="form.isRegister" style="width:100%"/>
        </FormItem>
        <FormItem label="地址" prop="address" >
          <Input v-model="form.address" style="width:100%"/>
        </FormItem>
        <FormItem label="0代表等待实名  1代表待提交证件，2代表已完成实名，,3代表实名驳回" prop="obligeeRealNameStatus" >
          <Input v-model="form.obligeeRealNameStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="mobilePhone" >
          <Input v-model="form.mobilePhone" style="width:100%"/>
        </FormItem>
        <FormItem label="" prop="email" >
          <Input v-model="form.email" style="width:100%"/>
        </FormItem>
        <FormItem label="如果法人为企业,这有‘企业法人姓名’" prop="legalName" >
          <Input v-model="form.legalName" style="width:100%"/>
        </FormItem>
        <FormItem label="如果法人为企业,这有‘企业法人身份证号’" prop="legalIdentityNo" >
          <Input v-model="form.legalIdentityNo" style="width:100%"/>
        </FormItem>
        <FormItem label="法人证件图片正面" prop="legalPicCardOn" >
          <Input v-model="form.legalPicCardOn" style="width:100%"/>
        </FormItem>
        <FormItem label="法人证件图片反面" prop="legalPicCardBack" >
          <Input v-model="form.legalPicCardBack" style="width:100%"/>
        </FormItem>
        <FormItem label="法人证件有效期开始时间" prop="legalStartTime" >
          <Input v-model="form.legalStartTime" style="width:100%"/>
        </FormItem>
        <FormItem label="法人证件有效期结束时间" prop="legalEndTime" >
          <Input v-model="form.legalEndTime" style="width:100%"/>
        </FormItem>
        <FormItem label="法人实名认证状态" prop="legalStatus" >
          <Input v-model="form.legalStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="法人实名认证原因" prop="legalVerifyReason" >
          <Input v-model="form.legalVerifyReason" style="width:100%"/>
        </FormItem>
        <FormItem label="是否修改过(0:未修改，1：修改)" prop="legalModifyFlag" >
          <Input v-model="form.legalModifyFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="权利人是否修改过(0:未修改，1：修改)" prop="modifyFlag" >
          <Input v-model="form.modifyFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="入境证明URL" prop="enterCertify" >
          <Input v-model="form.enterCertify" style="width:100%"/>
        </FormItem>
        <FormItem label="人工审核状态（待审核，审核通过，审核驳回）wait_real_name_audit：待审核 complete_real_name_audit：审核通过 reject_real_name：审核驳回" prop="artificialAuditStatus" >
          <Input v-model="form.artificialAuditStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="人工审核状态变化时间" prop="auditStatusTime" >
            <DatePicker type="date" v-model="form.auditStatusTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="银行预留手机号" prop="cardPhone" >
          <Input v-model="form.cardPhone" style="width:100%"/>
        </FormItem>
        <FormItem label="银行卡号" prop="cardNo" >
          <Input v-model="form.cardNo" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "RegisterPo",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_time", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        name: "",
        nickName: "",
        authMethod: "",
        obligeeType: "",
        identityType: "",
        identityNo: "",
        identityNoEncrypt: "",
        country: "",
        province: "",
        city: "",
        signature: "",
        registerId: "",
        attachment2: "",
        attachment2Uuid: "",
        attachment1: "",
        attachment1Uuid: "",
        attachment3: "",
        attachment3Uuid: "",
        attachment4: "",
        attachment5: "",
        attachStartTime: "",
        attachEndTime: "",
        createdAt: "",
        isRegister: "",
        address: "",
        obligeeRealNameStatus: "",
        mobilePhone: "",
        email: "",
        legalName: "",
        legalIdentityNo: "",
        legalPicCardOn: "",
        legalPicCardBack: "",
        legalStartTime: "",
        legalEndTime: "",
        legalStatus: "",
        legalVerifyReason: "",
        legalModifyFlag: "",
        modifyFlag: "",
        enterCertify: "",
        artificialAuditStatus: "",
        auditStatusTime: "",
        cardPhone: "",
        cardNo: "",
        remarks: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "用户姓名",
          key: "name",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "个人：笔名，企业：简称",
          key: "nickName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "认证方式  idcard：“身份证”  mainland_passport：“大陆护照”  mainland_officer  ：“大陆军官证” mainland_police ：大陆警官证 hongkong：“香港”   macao:澳门  taiwan：“台湾”  foreign ：“外籍” enterprise ：“企业”  ，这个字段主要用于组装天威诚信CA请求参数，不同的证件照采取不同的证件照",
          key: "authMethod",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利人类型：person：“个人”  enterprise “企业”   和旧版权家的type字段相对应",
          key: "obligeeType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件类型：1：身份证，2：护照，3：军官证  4：企业法人营业执照    5 组织机构代码证书   6 事业单位法人证书  7社团法人证书  8 警官证  9 其他类型",
          key: "identityType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件号码",
          key: "identityNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件号加密",
          key: "identityNoEncrypt",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "国家",
          key: "country",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "省份",
          key: "province",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "城市",
          key: "city",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "联系人",
          key: "signature",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "登记人ID",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件扫描件2",
          key: "attachment2",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "attachment2Uuid",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件扫描件1",
          key: "attachment1",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "attachment1Uuid",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件扫描件3",
          key: "attachment3",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "attachment3Uuid",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件扫描件4",
          key: "attachment4",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件扫描件5",
          key: "attachment5",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件有效期开始时间",
          key: "attachStartTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证件有效期结束时间",
          key: "attachEndTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建时间",
          key: "createdAt",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否是主要权利人0 不是  1是",
          key: "isRegister",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "0代表等待实名  1代表待提交证件，2代表已完成实名，,3代表实名驳回",
          key: "obligeeRealNameStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "mobilePhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "email",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "如果法人为企业,这有‘企业法人姓名’",
          key: "legalName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "如果法人为企业,这有‘企业法人身份证号’",
          key: "legalIdentityNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人证件图片正面",
          key: "legalPicCardOn",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人证件图片反面",
          key: "legalPicCardBack",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人证件有效期开始时间",
          key: "legalStartTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人证件有效期结束时间",
          key: "legalEndTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人实名认证状态",
          key: "legalStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人实名认证原因",
          key: "legalVerifyReason",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否修改过(0:未修改，1：修改)",
          key: "legalModifyFlag",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利人是否修改过(0:未修改，1：修改)",
          key: "modifyFlag",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "入境证明URL",
          key: "enterCertify",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "人工审核状态（待审核，审核通过，审核驳回）wait_real_name_audit：待审核 complete_real_name_audit：审核通过 reject_real_name：审核驳回",
          key: "artificialAuditStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "人工审核状态变化时间",
          key: "auditStatusTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "银行预留手机号",
          key: "cardPhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "银行卡号",
          key: "cardNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      // this.getRequest("请求路径", this.searchForm).then(res => {
      //   this.loading = false;
      //   if (res.success) {
      //     this.data = res.result.content;
      //     this.total = res.result.totalElements;
      //   }
      // });
      // 以下为模拟数据
      //this.data = [
      //];
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>